import React from "react";
import { PConfirmPopupStyle as S } from "./PConfirmPopup.style";
import { ConfirmPopup, ConfirmPopupProps } from "primereact/confirmpopup";

export const PConfirmPopup = React.forwardRef<ConfirmPopup, ConfirmPopupProps>((props, ref) => (
  <S.PConfirmPopup {...props} ref={ref} />
));
